import { render, staticRenderFns } from "./NovaTable.vue?vue&type=template&id=2e82c7b0&"
import script from "./NovaTable.vue?vue&type=script&lang=js&"
export * from "./NovaTable.vue?vue&type=script&lang=js&"
import style0 from "./NovaTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports